import React from 'react';


const ToDo = (props)=>{
  console.log(props.data);


  let done = 'text-decoration: line-through; background-color: green;}';
  let hold = 'background-color: darkgrey;}';
  let now = 'background-color: red;}';

  
  
  return(
   
  <div className='mypage fluid-container p-3'>
  

  
  <h6>Key</h6>
  
  <ul>
    <li Style={now}>Current Priority</li>
    <li Style={hold}>On Hold</li>
    <li Style={done}>Done</li>
  </ul>
  <ol>
  <h4>To Do</h4>
  <li Style={done}>Integrate React Router(Check) (7/3/2018)</li>
    <li>Create Home Page(inProgress...)<ul>
        <li Style={done}>Clone TODO build HOME (AddTo Do as component)(7/3/2018)</li>
        <li Style={done}>Change TODO link to HOME(7/3/2018)</li>
        <li Style={done}>Import TODO into HOME (much change TODO and HOME about NO CHANGE)(7/5/2018)</li>
        <li Style={done}>Redesign Home1(7/6/2018)</li>
        <li Style={hold}>Redesign Home2 with content engine</li>
      </ul></li>        
    <li  Style={done}>Create Login Page(7/9/2018)

      <ul>
        <li Style={done}>Add Link to Registration Page</li>
      </ul>
      <li Style={done}>Get Login to set usr in express with passport(7/5/2018)</li>
      
      </li>                 
    
    <li Style={done}>Create Register Request Page(7/9/2018)<ul>
      <li Style={done}>Integrate Function from React through express and sql(7/5/2018)</li>
      <li Style={done }>Send Email (from local)(7/5/2018)</li>
      <li>Add Validations<ul><li>email format</li><li>password match; length</li></ul></li>
      <li>Handle Return: 3 States (Pending EULA Page...) <ul>    <li>StateLoaded</li>
          <li>StateFoundUser</li>
          <li>StateEmailSent</li></ul></li>
	</ul></li> 
    <li Style={done }>Create Email Confirm EULA/Policy and AutoSignIn(7/9/2018)</li>
    <li Style={done}>Create Password Reset System
      <ul>
      <li>Password Reset Request Page</li>
      <li>Password Reset Email</li>
      <li>Password Reset Page</li>
      </ul>
    </li>

    <li Style={done}>Get up on Heroku</li>
    <li Style={now}>Fix Directory Structure</li>
    <li Style={done}>Create Games Page</li>
    <li Style={hold}>Games Chat Component</li>
    <li Style={hold}>Create Game Launcher<ul>
      <li>Single Player</li>
      <li>Multiplayer Lobby</li>
      </ul></li>
    <li Style={done} >Import Sweeper?(7/13/2018)</li>
    <li>Create Game<ul>
      <li>Make Up Game (In Progress...)<ul>
        
        <li Style={done}>Overarching Site Integration Plan(7/5/2018)</li>
        <li Style={done}>Class Themes and Inspiration(7/5/2018)</li>
        <li Style={done}>Basic Premis(7/5/2018)</li>
        <li Style={done}>First Pass Stats Class Skills Theme(7/5/2018)</li>
        
        <li Style={now}>Improvise?</li>
        </ul></li>
      <li Style={now}>Code Game<ul>
        <li>Import Mongo</li>
        <li>Rough Design Doc</li>        
        <li>Data Architecture</li>
        <li>High Score System</li>
        
        </ul></li> 
      <li  Style={now}>Game Assets<ul>
        <li>Finish Shooting</li>
        <li>Edit Prep Animations</li>
        <li>Install Animation Library</li>
        </ul></li>

      <li Style={hold}>Integrate Loot System</li>
      </ul></li>
    
    <li Style={hold}>Create Loot Page</li>
         
    <li Style={hold}>Create Site Player Inventory Page</li>
    <li Style={hold}>Create Game Site Loot API</li>
    
    <li Style={hold}> Create Admin Content Engine</li>
    <li Style={hold}>Create Site Wide Auction House</li>
    <li Style={hold}>Create Convenience Shop?</li>
  </ol>
  </div>)};

export default ToDo;    


// WEBPACK FOOTER //
// ./src/container/Pages/ToDo.js